import { apiFetch } from '@/lib/api';

export interface AttendeeDTO {
  id: string;
  event_id: string;
  full_name: string;
  first_name: string;
  last_name: string;
  email?: string | null;
  phone?: string | null;
  city?: string | null;
  region?: string | null;
  country_iso2?: string | null;
  postal_code?: string | null;
  address_line?: string | null;
  lat?: number | null;
  lon?: number | null;
  place_id?: string | null;
  nearest_airports?: Array<{
    iata: string;
    name: string;
    distance_km: number;
    rank: number;
    source: string;
  }>;
}

export interface Paginated<T> {
  items: T[];
  pagination: { page: number; pageSize: number; totalItems: number; totalPages: number };
}

export class AttendeesService {
  async listByEvent(eventId: string, page = 1, pageSize = 20): Promise<Paginated<AttendeeDTO>> {
    const res = await apiFetch(`/api/events/${eventId}/attendees?page=${page}&pageSize=${pageSize}`);
    if (!res.ok) throw new Error('Failed to fetch attendees');
    const data = await res.json();
    return data.data as Paginated<AttendeeDTO>;
  }

  async get(id: string): Promise<AttendeeDTO> {
    const res = await apiFetch(`/api/attendees/${id}`);
    if (!res.ok) throw new Error('Failed to fetch attendee');
    const data = await res.json();
    return data.data as AttendeeDTO;
  }

  async create(eventId: string, input: { 
    first_name: string; 
    last_name: string; 
    email?: string; 
    phone?: string;
    city?: string;
    region?: string;
    country_iso2?: string;
    postal_code?: string;
    address_line?: string;
  }): Promise<{ id: string }> {
    const res = await apiFetch(`/api/events/${eventId}/attendees`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (!res.ok) throw new Error('Failed to create attendee');
    const data = await res.json();
    return data.data as { id: string };
  }

  async update(id: string, updates: {
    first_name?: string;
    last_name?: string;
    email?: string;
    phone?: string;
    city?: string;
    region?: string;
    country_iso2?: string;
    postal_code?: string;
    address_line?: string;
    external_ref?: string;
  }): Promise<void> {
    const res = await apiFetch(`/api/attendees/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    if (!res.ok) throw new Error('Failed to update attendee');
  }

  async delete(id: string): Promise<void> {
    const res = await apiFetch(`/api/attendees/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete attendee');
  }
}


